
export default (width = 24, height = 24, color = '#797979') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
        <circle cx="12" cy="12" r="9" stroke="${color}" stroke-width="1.6"/>
        <rect width="2" height="28" x="11" y="-2" fill="${color}" rx="1" transform="rotate(45 12 12)"/>
    </g>
</svg>
`